import RequestAbstract from "../abstract";

export default class PublicFrauds extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-frauds';
    }
    updateStatus = async (id, status) => {
        return this.loadWithAuth(`${this.link}/set/${id}/status/${status}`, {
            method: 'GET'
        });
    };
}
